"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getHotelRoomRatesByDate = void 0;
const orders_1 = require("../orders");
const getHotelRoomAvailability_1 = require("./getHotelRoomAvailability");
const getHotelContracts_1 = require("./getHotelContracts");
const getHotelRoomRatesByDate = (hotel, check_in_date, number_of_nights, contract_type) => {
    const date_ranges = (0, orders_1.getDateRange)(check_in_date, number_of_nights);
    const contracts = (0, getHotelContracts_1.getHotelContracts)(hotel.contracts, check_in_date, number_of_nights);
    const availaility = (0, getHotelRoomAvailability_1.getHotelRoomAvailability)(date_ranges, contracts, contract_type);
    return availaility;
};
exports.getHotelRoomRatesByDate = getHotelRoomRatesByDate;
